import picsioUtils from '@picsio/utils';
import picsioConfig from '../../../../../../config';
import l10n from '../../../shared/strings';
import Logger from '../../../services/Logger';

export default function uploadFile(file, additionalFields, onUploadProgress = () => { }, signal) {
  const contentType = picsioUtils.lookupMimeType(file.name.split('.').pop()) || 'application/octet-stream';

  const inboxApiUrl = window.inbox.uploadUrl || picsioConfig.inboxesBaseUrl || '';
  const url = `${inboxApiUrl}/upload/${window.inbox._id}?title=${encodeURIComponent(file.name)}&contentLength=${file.size}&contentType=${encodeURIComponent(contentType)}`;

  const formData = new FormData();
  formData.append('file', file);
  formData.append('additionalFields', JSON.stringify(additionalFields));

  return new Promise((resolve, reject) => {
    let isCancelled = false;
    const xhr = new XMLHttpRequest();
    const handleAbort = () => {
      if (xhr) xhr.abort();
      isCancelled = true;
    };
    signal.addEventListener('abort', handleAbort);
    xhr.upload.onprogress = ({ loaded, total }) => onUploadProgress({ percentage: (loaded / total) * 100, xhr, total });
    xhr.onload = (res) => {
      if (res.target.status === 200) {
        resolve();
      } else {
        const err = new Error(`Upload failed with status ${res.target.status}`);
        err.response = res.target;
        reject(err);
      }
    };
    xhr.onabort = () => {
      const err = new Error('Upload cancelled');
      err.isCancelled = true;
      reject(err);
    };
    xhr.onerror = (response) => {
      if (response.error && response.error.status === 500) {
        Logger.error(new Error('Import: internal server error'), { error: response }, [
          'ImportBadResponseFromDB',
          { errorMessage: (response.error && response.error.message) || 'NoMessage' },
        ]);
        const err500 = new Error(l10n.IMPORT.textCantSaveImageToDB);
        err500.code = 500;
        err500.reason = 'internalServerError';
        reject(err500);
      } else {
        Logger.error(new Error('Import: bad response from storage'), { error: response }, [
          'ImportBadResponseFromStorage',
          { errorMessage: 'Import: bad response from storage' },
        ]);
        const err403 = new Error(l10n.IMPORT.textCantSaveImageToStorage);
        err403.code = 403;
        err403.reason = 'badResponse';
        reject(err403);
      }
    };
    xhr.open('PUT', url, true);
    xhr.timeout = 1000 * 60 * 120; // 2h
    xhr.send(formData);
  });
}
